// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading-module_loading_35HkB"};